import request from 'src/shared/utils/requester';

const USE_CASE_URL = 'payments';

const deletePaymentById = async (paymentId) => {
  const method = 'DELETE';
  const url = `${USE_CASE_URL}/${paymentId}`;

  const json = await request({ method, url });
  return json;
};

export default deletePaymentById;
